export class Media {
    id: number;
    url: string;
    owner_id: number;
    created_at: string;
    updated_at: string;
    type: string;
    constructor(media?) {
        if (media) {
            this.id = media.id || null;
            this.url = media.url || null;
            this.owner_id = media.owner_id || null;
            this.created_at = media.created_at || null;
            this.updated_at = media.updated_at || null;
            this.type = media.type || null;
        }
    }
}
